import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from '@/hooks/Intel/client'

export const transformsLocations = data => {
  const tree = data
  const list = []
  const sourceRegionList = []

  for (const region of tree.regions) {
    list.push({
      type: 'region',
      id: region.region_id,
      name: region.region_name,
    })
    sourceRegionList.push({
      type: 'region',
      id: 'source-region--' + region.region_id?.split('location--')?.at(1),
      name: region.region_name,
    })
    for (const subregion of region.subregions) {
      list.push({
        type: 'subregion',
        id: subregion.subregion_id,
        name: subregion.subregion_name,
        region_id: region.region_id,
        parent_id: region.region_id,
        parent: region.region_name,
      })
      sourceRegionList.push({
        type: 'subregion',
        id: 'source-region--' + subregion.subregion_id?.split('location--')?.at(1),
        name: subregion.subregion_name,
        region_id: 'source-region--' + region.region_id?.split('location--')?.at(1),
        parent_id: region.region_id,
        parent: region.region_name,
      })

      for (const country of subregion.countries) {
        list.push({
          type: 'country',
          id: country.country_id,
          name: country.country_name,
          iso2: country.country_iso2,
          parent_id: subregion.subregion_id,
          parent: subregion.subregion_name,
        })
        sourceRegionList.push({
          type: 'country',
          id: 'source-region--' + country.country_id?.split('location--')?.at(1),
          name: country.country_name,
          iso2: country.country_iso2,
          parent_id: 'source-region--' + subregion.subregion_id?.split('location--')?.at(1),
          parent: subregion.subregion_name,
        })
      }
    }
  }

  list.sort((a, b) => a.name.localeCompare(b.name))
  sourceRegionList.sort((a, b) => a.name.localeCompare(b.name))

  const map = {}

  for (const item of list) {
    map[item.id] = item
  }

  return { tree, map, list, sourceRegionList }
}

export const adaptersLocations = {
  list: data => data.list,
  sourceRegionList: data => data.sourceRegionList,
  map: data => data.map,
  tree: data => data.tree,
}
adaptersLocations.default = adaptersLocations.list

export const useLocationsVocabQuery = (options = {}) => {
  const cli = useMatiApiClient()

  return useQuery({
    ...options,
    queryFn: () => cli.locations.fetchVocab().then(transformsLocations),
    queryKey: ['locationsVocab'],
    select: options.select || adaptersLocations[options.adapter] || adaptersLocations.default,
  })
}
